export default __webpack_public_path__ + "static/media/Snd4.12c8ce1b.mp3";